import React from "react";
import Layout from "../components/layout/layout";
import Hero from "./Events/hero";
import Info from "./Events/info";

const Events = () => {
    return (
        <Layout>
            <Hero />
            <Info />
        </Layout>
    );
};

export default Events;
